import Swiper from 'swiper';

const initCarousel = () => {
	const components = document.querySelectorAll( 'section.cds2-carousel' );

	if ( !components.length )
	{
		return;
	}

	components.forEach( ( component ) => {
		const slides = component.querySelectorAll( 'li.swiper-slide' );

		slides.forEach( ( slide ) => {
			let playPromise;

			slide.addEventListener( 'mouseenter', ( {target} ) => {
				const videoWrapper = target.querySelector( 'div.preview > video' );

				if ( videoWrapper )
				{	
					playPromise = videoWrapper.play();
					
					if ( playPromise !== undefined )
					{
						playPromise.then(() => {}).catch((error) => {
							console.error('Ошибка воспроизведения:', error);
						});
					}
				}
			} );

			slide.addEventListener( 'mouseleave', ( {target} ) => {
				const videoWrapper = target.querySelector( 'div.preview > video' );

				 if (playPromise !== undefined) {
					videoWrapper.pause();
				}
			} );
		} );

		if ( !component.classList.contains( 'list' ) )
		{
			const slidesWrapper = component.querySelector( 'ul.swiper-wrapper' );
			const currentSlider = component.querySelector( 'div.swiper-cds2-carousel' );

			const swiper = new Swiper( currentSlider, {
				slidesPerView: 'auto',
				freeMode: true,
			} );

			swiper.on( 'touchStart', () => {
				slidesWrapper.classList.add( 'with-mouse' );
				component.classList.add( 'with-mouse' );
			});
		}
	} );
};

export {
	initCarousel,
};
